<template>
  <v-card class="card-container">
    <div class="main-toolbar mb-4">
      <div class="icon-back">
        <v-img
          src="../../../assets/figmaIcons/white/standchecklist.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">Checklist - Manutenção Preventiva</span>
    </div>

    <div class="hidden-md-and-up">
      <v-tabs
        :height="40"
        :mobile-break-point="300"
        v-model="tab"
        class="ma-auto"
        icons-and-text
        @change="updateComponent"
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              class="rounded-lg rounded-b-0"
              v-on="on"
              v-bind="attrs"
              href="#tabOs"
            >
              <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-tab>
          </template>
          <span>Checklist OS</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              class="rounded-lg rounded-b-0"
              v-show="userType < 4 || userType >= 7"
              v-on="on"
              v-bind="attrs"
              href="#tabTemplate"
            >
              <v-icon>mdi-form-select</v-icon>
            </v-tab>
          </template>
          <span>Checklist Itens</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              class="rounded-lg rounded-b-0"
              v-show="userType < 4 || userType >= 7"
              v-on="on"
              v-bind="attrs"
              href="#tabItem"
            >
              <v-icon>mdi-format-list-checkbox</v-icon>
            </v-tab>
          </template>
          <span>Checklist Itens</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              class="rounded-lg rounded-b-0"
              v-show="userType < 4 || userType >= 7"
              v-on="on"
              v-bind="attrs"
              href="#tabClass"
            >
              <v-icon>mdi-file-tree-outline</v-icon>
            </v-tab>
          </template>
          <span>Checklist Classe</span>
        </v-tooltip>
      </v-tabs>
    </div>

    <div class="hidden-sm-and-down">
      <v-tabs
        :height="40"
        :mobile-break-point="360"
        v-model="tab"
        class="ma-0"
        icons-and-text
        @change="updateComponent"
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tab
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
          href="#tabOs"
        >
          Checklist O.S.
          <v-icon class="mt-1 mr-2">mdi-checkbox-marked-outline</v-icon>
        </v-tab>
        <v-tab
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
          v-show="userType < 4 || userType >= 7"
          href="#tabTemplate"
        >
          Checklist Template
          <v-icon class="mt-1 mr-2">mdi-form-select</v-icon>
        </v-tab>
        <v-tab
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
          v-show="userType < 4 || userType >= 7"
          href="#tabItem"
        >
          Checklist Itens
          <v-icon class="mt-1 mr-2">mdi-format-list-checkbox</v-icon>
        </v-tab>
        <v-tab
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
          v-show="userType < 4 || userType >= 7"
          href="#tabClass"
        >
          Checklist Classe
          <v-icon class="mt-1 mr-2">mdi-file-tree-outline</v-icon>
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="tab">
      <v-tab-item value="tabOs">
        <v-card flat class="mt-0">
          <ChecklistOSPage />
        </v-card>
      </v-tab-item>
      <v-tab-item value="tabTemplate">
        <keep-alive>
          <v-card flat class="mt-0">
            <ChecklistTemplateTable ref="template" />
          </v-card>
        </keep-alive>
      </v-tab-item>
      <v-tab-item value="tabItem">
        <v-card flat class="mt-0">
          <ChecklistItemTable />
        </v-card>
      </v-tab-item>
      <v-tab-item value="tabClass">
        <v-card flat class="mt-0">
          <ChecklistItemClassTable />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<style scoped>
.v-tabs--icons-and-text > .v-tabs-bar .v-tab {
  flex-direction: row-reverse;
}

.v-tab.v-tab {
  color: #bbcf20;
}

.v-tab {
  text-transform: none;
}

.v-tab--active {
  background-color: #e7eaeb;
}
</style>

<script>
import ChecklistOSPage from './components/ChecklistServiceOrder/checklistServiceOrderTable.vue'
import ChecklistItemClassTable from './components/checklistItemClass/ChecklistItemClassTable.vue'
import ChecklistItemTable from './components/checklistItem/ChecklistItemTable.vue'
import ChecklistTemplateTable from './components/checklistTemplate/ChecklistTemplateTable.vue'

export default {
  components: {
    ChecklistOSPage,
    ChecklistItemClassTable,
    ChecklistItemTable,
    ChecklistTemplateTable,
  },

  created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
  },

  data: () => ({
    tab: null,
    userType: null,
  }),

  methods: {
    updateComponent() {
      if (this.tab === 'tabTemplate' && this.$refs.template) {
        this.$refs.template.getChecklisItemClasses()
        this.$refs.template.getStandardEquipments()
      }
    },
  },
}
</script>
